import styled from 'styled-components/native';

export const ChatItemDialogBody = styled.ScrollView`
  padding: 15px;
  width: 100%;
`;
